import lottie from "lottie-web";

// Lottieアニメーションのアスペクト比を保ったまま最大限表示する関数
const resizeLottieToFit = (container, animation) => {
  const resizeHandler = () => {
    const parent = container.parentElement;
    if (!parent) return;
    
    const parentRect = parent.getBoundingClientRect();
    const animationData = animation.animationData;
    if (!animationData) return;
    
    const animationWidth = animationData.w;
    const animationHeight = animationData.h;
    
    // コンテナサイズを元のアニメーションサイズに設定
    container.style.width = `${animationWidth}px`;
    container.style.height = `${animationHeight}px`;
    
    // 親要素のアスペクト比とアニメーションのアスペクト比を比較
    const parentAspect = parentRect.width / parentRect.height;
    const animationAspect = animationWidth / animationHeight;
    
    let scale;
    if (parentAspect > animationAspect) {
      // 親が横長 → 横幅に合わせてスケール
      scale = parentRect.width / animationWidth;
    } else {
      // 親が縦長 → 縦幅に合わせてスケール
      scale = parentRect.height / animationHeight;
    }
    
    // transformでスケールを適用
    container.style.transform = `translate(-50%, -50%) scale(${scale})`;
  };
  
  // 初回実行
  setTimeout(resizeHandler, 100);
  
  // リサイズイベントに登録
  window.addEventListener('resize', resizeHandler);
  
  // アニメーション読み込み完了時にも実行
  animation.addEventListener('DOMLoaded', resizeHandler);
};

export const lottieAnimation = () => {
  const containers = document.querySelectorAll(".js-lottie-container");
  // ローディングアニメーションを毎回表示するか（true: 毎回, false: セッション中1回）
  const showLoadingEveryTime = true;
  const hasSeenLoading = showLoadingEveryTime ? false : sessionStorage.getItem("hasSeenLoading");

  containers.forEach((container) => {
    const path = container.dataset.lottiePath;
    const loop = container.dataset.lottieLoop !== "false";
    const autoplay = container.dataset.lottieAutoplay !== "false";
    const renderer = container.dataset.lottieRenderer || "svg";

    if (path) {
      const animation = lottie.loadAnimation({
        container: container,
        renderer: renderer,
        loop: loop,
        autoplay: autoplay,
        path: path,
      });

      animation.addEventListener("DOMLoaded", () => {
        container.classList.add("lottie-loaded");

        // MVアニメーション用にインスタンスを保存
        if (container.classList.contains("js-mv-animation")) {
          container.lottieInstance = animation;
          
          // PC版のみアスペクト比を保ったまま最大限表示するための処理
          if (container.classList.contains("u-pc-only")) {
            resizeLottieToFit(container, animation);
          }

          // ローディングを見た事がある場合はすぐにMVアニメーションを開始
          if (hasSeenLoading) {
            animation.play();
          }
        }

        // ローディングアニメーションの処理
        if (container.classList.contains("js-loading-animation")) {
          if (hasSeenLoading) {
            // 既にローディングを見ている場合はローディングを非表示にしてMVアニメーションを開始
            const loadingElement = document.querySelector(".loading");
            if (loadingElement) {
              loadingElement.style.display = "none";
            }

            // MVアニメーションを開始
            const mvAnimations = document.querySelectorAll(".js-mv-animation");
            mvAnimations.forEach((mvContainer) => {
              if (mvContainer.lottieInstance) {
                mvContainer.lottieInstance.play();
              }
            });
          } else {
            // 初回のみローディングアニメーションを表示
            // 0.5s待機 → 0.5sでフェードイン → アニメーション開始
            setTimeout(() => {
              container.style.transition = "opacity 0.5s ease";
              container.style.opacity = "1";
              setTimeout(() => {
                animation.play();
              }, 500);
            }, 500);
          }
        }
      });

      animation.addEventListener("complete", () => {
        container.classList.add("lottie-complete");

        // ローディングアニメーション完了時の処理
        if (container.classList.contains("js-loading-animation")) {
          // sessionStorageにローディング表示済みフラグを保存（毎回表示の場合は保存しない）
          if (!showLoadingEveryTime) {
            sessionStorage.setItem("hasSeenLoading", "true");
          }

          const loadingElement = document.querySelector(".loading");
          if (loadingElement) {
            setTimeout(() => {
              loadingElement.style.transition = "opacity 0.5s ease";
              loadingElement.style.opacity = "0";
              setTimeout(() => {
                loadingElement.style.display = "none";

                // ローディング完了後にMVアニメーションを開始
                const mvAnimations = document.querySelectorAll(".js-mv-animation");
                mvAnimations.forEach((mvContainer) => {
                  if (mvContainer.lottieInstance) {
                    mvContainer.lottieInstance.play();
                  }
                });
              }, 500);
            }, 500);
          }
        }
      });
    }
  });
};
